export default "__VITE_ASSET__JbXIqZq4__"